"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecursiveOperationRpcLocal = void 0;
const utils_1 = require("@streamr/utils");
const DhtRpc_1 = require("../../../generated/packages/dht/protos/DhtRpc");
const RouterRpcLocal_1 = require("../routing/RouterRpcLocal");
const getPreviousPeer_1 = require("../routing/getPreviousPeer");
const identifiers_1 = require("../../identifiers");
const logger = new utils_1.Logger(module);
class RecursiveOperationRpcLocal {
    options;
    constructor(options) {
        this.options = options;
    }
    async routeRequest(routedMessage) {
        if (this.options.isMostLikelyDuplicate(routedMessage.requestId)) {
            return (0, RouterRpcLocal_1.createRouteMessageAck)(routedMessage, DhtRpc_1.RouteMessageError.DUPLICATE);
        }
        const remoteNodeId = (0, identifiers_1.toNodeId)((0, getPreviousPeer_1.getPreviousPeer)(routedMessage) ?? routedMessage.sourcePeer);
        logger.trace(`Received routeRequest call from ${remoteNodeId}`);
        this.options.addToDuplicateDetector(routedMessage.requestId);
        return this.options.doRouteRequest(routedMessage);
    }
}
exports.RecursiveOperationRpcLocal = RecursiveOperationRpcLocal;
//# sourceMappingURL=RecursiveOperationRpcLocal.js.map